import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Store, select } from "@ngrx/store";
import { userDetailsPayload } from "src/app/app-store/user/user.selector";
import { Subscription } from "rxjs";

@Component({
  selector: "app-check-in-outdialog",
  templateUrl: "./check-in-outdialog.component.html",
  styleUrls: ["./check-in-outdialog.component.css"],
})
export class CheckInOutdialogComponent implements OnInit, OnDestroy {
  mobileImage = "assets/images/checkout_mobile_img.png";
  desktopImage = "assets/images/checkout_img.png";
  checkInMobileImage = "assets/images/checkin_mobile_img.png";
  checkInDesktopImage = "assets/images/checkin_img.png";
  imageLoading = true;

  userDetailSubscription: Subscription;
  constructor(
    private dialogRef: MatDialogRef<CheckInOutdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.userDetailSubscription = this.store
      .pipe(select(userDetailsPayload))
      .subscribe((response) => {
        if (response.preferredLanguage !== "English") {
          this.mobileImage = "assets/images/checkout_mobile_img.png";
          this.desktopImage = "assets/images/checkout_img.png";
          this.checkInMobileImage = "assets/images/checkin_mobile_img.png";
          this.checkInDesktopImage = "assets/images/checkin_img.png";
        }
      });
  }

  setLoaded() {
    this.imageLoading = false;
  }

  ok = () => {
    this.dialogRef.close(this.data.error);
  };

  ngOnDestroy() {
    if (this.userDetailSubscription) {
      this.userDetailSubscription.unsubscribe();
    }
  }
}
